import React, { useState } from "react";
import "leaflet/dist/leaflet.css";
import "./ClimateMonitoring.css";
import {  Form } from 'react-bootstrap';
import CanvasJSReact from '@canvasjs/react-charts';
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
const ClimateMonitoring = () => {
    const [formData, setFormData] = useState({
        cycloneName: "No selection",
        date: "No selection",
        bulletin: "No selection",
    });

  const [, setSubmittedData] = useState(null);

  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = () => {
    setSubmittedData(formData);
  };

  // Check if any dropdown is still set to "No selection"
  const isFormIncomplete = Object.values(formData).includes("No selection");
  const DischargeOp = {
    theme: "light2",
    animationEnabled: true,
    exportEnabled: true,
    title: {
        text: "Climate Outllok of Basin : Basin 1, Station 2"
    },
    axisX: {
        valueFormatString: "MMM",
        interval: 1,
        intervalType: "month"
    },
    toolTip: {
        shared: true
    },
    legend: {
        cursor: "pointer",
        itemclick: function (e) {
            if (typeof (e.dataSeries.visible) === "undefined" || e.dataSeries.visible) {
                e.dataSeries.visible = false;
            } else {
                e.dataSeries.visible = true;
            }
            e.chart.render();
        }
    },
    data: [{
        type: "spline",
        xValueFormatString: "MMM",
        yValueFormatString: "#,###.## m3/s",
        name: "Forecast",
        showInLegend: true,
        dataPoints: [
            { x: new Date(2020, 0, 1), y: 14.1 },
            { x: new Date(2020, 1, 1), y: 185 },
            { x: new Date(2020, 2, 1), y: 17.2 },
            { x: new Date(2020, 3, 1), y: 20.8 },
            { x: new Date(2020, 4, 1), y: 24.4 },
            { x: new Date(2020, 5, 1), y: 26.6 },
            { x: new Date(2020, 6, 1), y: 29.2 },
            { x: new Date(2020, 7, 1), y: 290.2 },
            { x: new Date(2020, 8, 1), y: 26.9 },
            { x: new Date(2020, 9, 1), y: 23.5 },
            { x: new Date(2020, 10, 1), y: 190.7 },
            { x: new Date(2020, 11, 1), y: 15.8 }
        ]
    }]
};

    return (
    <div className="wind-speed-cyclone-container">
        <div className="head-box">
            {/* Left Side: Dropdowns and Submit Button */}
            <div className="form-container">
            <div className="dropdown-group">
                <div className="dropdown-container">
                    <h4 className="dropdown-heading">Select Basin</h4>
                    <select
                        name="cycloneName"
                        className="dropdown"
                        value={formData.cycloneName}
                        onChange={handleChange}
                    >
                        <option value="No selection">No selection</option>
                        <option>Basin 1</option>
                        <option>Basin 2</option>
                        <option>Basin 3</option>
                    </select>
                </div>

                <div className="dropdown-container">
                    <h4 className="dropdown-heading">Select Station</h4>
                    <select
                        name="date"
                        className="dropdown"
                        value={formData.date}
                        onChange={handleChange}
                    >
                        <option value="No selection">No selection</option>
                        <option>Station 1</option>
                        <option>Station 2</option>
                        <option>Station 3</option>
                    </select>
                </div>

                <div className="dropdown-container">
                    <h4 className="dropdown-heading">Select Parameter</h4>
                    <select
                        name="date"
                        className="dropdown"
                        value={formData.date}
                        onChange={handleChange}
                    >
                        <option>Rainfall</option>
                    </select>
                </div>

                {/* Date and Time */}
                <Form.Group className="mb-3" controlId="formGroupDateTime">
                    <Form.Label className="labeltext">Start Date</Form.Label>
                    <Form.Control type="datetime-local" />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formGroupDateTime">
                    <Form.Label className="labeltext">End Date</Form.Label>
                    <Form.Control type="datetime-local" />
                </Form.Group>


                {/* Submit button */}
                <button
                className="submit-button"
                onClick={handleSubmit}
                disabled={isFormIncomplete}
                >
                Submit
                </button>
            </div>
            </div>

        </div>
        <div className="row">
            <div className="col-md-12">
                <div className="box box-success">
                    <div className="box-header with-border">
                        <div className="table-responsive">
                            <table id="st_info_table" className="table table-bordered table-condensed">
                                <tbody><tr>
                                    <th >Basin Name</th>
                                    <th >Station Name</th>
                                </tr>
                                <tr>
                                    <td ><i>Basin 1</i></td>
                                    <td ><i>Station 2 </i></td>
                                </tr>
                            </tbody></table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">    
            <CanvasJSChart options={DischargeOp} /* onRef={ref => this.chart = ref} */ />
        </div>
    </div>
    );
};
export default ClimateMonitoring;